// src/app/views/pages_predict/g7/rtPrG7.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

// Store the exam code extension to avoid redundancy
const examCodeExt = EXAM_TYPES.G7.rid_cd_ext;

const G7Verify = Loadable(lazy(() => import("./G7Verify")));
const G7Mark = Loadable(lazy(() => import("./G7Mark")));
const G7Survey = Loadable(lazy(() => import("./G7Survey")));
const G7Result = Loadable(lazy(() => import("./G7Result")));
// const G7Score = Loadable(lazy(() => import("./G7Score")));

const rtPrG7 = [
  { path: `/pre/${EXAM_TYPES.G7.rid_cd_ext}/verify`, element: <G7Verify /> },
  { path: `/pre/${EXAM_TYPES.G7.rid_cd_ext}/mark`, element: <G7Mark /> },
  { path: `/pre/${EXAM_TYPES.G7.rid_cd_ext}/survey`, element: <G7Survey /> },
  { path: `/pre/${EXAM_TYPES.G7.rid_cd_ext}/result`, element: <G7Result /> },
  // { path: `/pre/score`, element: <G7Score /> },
];
export default rtPrG7;
